import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export interface FileListRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  workOrderID?: number;
  unitID?: number;
  tempEntityID?: any;
  planReviewTaskID?: number;
}

const getFileQueryStrings = (filter: FileListRequestArgs) => {
  const {
    customerID,
    officeID,
    projectID,
    unitID,
    workOrderID,
    tempEntityID,
    planReviewTaskID
  } = filter;

  let queryString = '';

  if (customerID) {
    queryString += `${queryString ? '&' : ''}CustomerID=${customerID}`;
  }
  if (officeID) {
    queryString += `${queryString ? '&' : ''}OfficeID=${officeID}`;
  }
  if (projectID) {
    queryString += `${queryString ? '&' : ''}ProjectID=${projectID}`;
  }
  if (unitID) {
    queryString += `${queryString ? '&' : ''}UnitID=${unitID}`;
  }
  if (workOrderID) {
    queryString += `${queryString ? '&' : ''}WorkOrderID=${workOrderID}`;
  }
  if (tempEntityID) {
    queryString += `${queryString ? '&' : ''}TempEntityID=${tempEntityID}`;
  }
  if (planReviewTaskID) {
    queryString += `${queryString ? '&' : ''}PlanReviewTaskID=${planReviewTaskID}`;
  }
  return queryString;
};

export const fileUploadApiKeyStore = {
  uploadFile: (): MutationKeyConfig => ({
    mutationKey: [`UPLOAD_FILE`],
    route: `/File`,
    action: 'POST',
  }),
  uploadPlanFiles: (): MutationKeyConfig => ({
    mutationKey: [`UPLOAD_PLAN_FILES`],
    route: `/Plan/PlanFileSave`,
    action: 'POST',
  }),
  deleteFile: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_FILE`],
    route: `/File/${id}`,
    action: 'DELETE',
  }),
  downloadFile: (): MutationKeyConfig => ({
    mutationKey: [`DOWNLOAD_FILE`],
    route: `/File/Download`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getFiles: (args: FileListRequestArgs): QueryKeyConfig => ({
    queryKey: [`GET_FILES`, ...[args.customerID, args.tempEntityID, args.officeID, args.projectID, args.workOrderID, args.unitID].filter((a) => a)],
    route: `/File?${getFileQueryStrings(args)}`,
    isEnabled: !!args && (!!args.customerID || !!args.officeID || !!args.projectID || !!args.workOrderID || !!args.unitID || !!args.tempEntityID),
  }),
  getFilesForPlanReview: (args: FileListRequestArgs): QueryKeyConfig => ({
    queryKey: [`GET_FILES_FOR_PLAN_REVIEW`, ...[args.customerID, args.tempEntityID, args.officeID, args.projectID, args.workOrderID, args.unitID].filter((a) => a)],
    route: `/File/GetFilesForPlanReview?${getFileQueryStrings(args)}`,
    isEnabled: !!args && (!!args.customerID || !!args.officeID || !!args.projectID || !!args.workOrderID || !!args.unitID || !!args.tempEntityID),
  }),
  updateUploadFile: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_UPLOAD_FILES`],
    route: `/File`,
    action: 'PUT',
  }),
  downloadFiles: (): MutationKeyConfig => ({
    mutationKey: [`DOWNLOAD_FILES`],
    route: `/File/DownloadFileList`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getFileTypes: (args: string): QueryKeyConfig => ({
    queryKey: [`GET_FILETYPES`],
    route: `/File/${args}/Types`,
  }),
  getFFExceptionFileList: (queueID: string, workorderNumber: any): QueryKeyConfig => ({
    queryKey: [`GET_FF_EXCEPTION_FILE`, queueID, workorderNumber],
    route: `/File/GetFFExceptionFileList?ExceptionQueueID=${queueID}&WorkorderNumber=${workorderNumber}`,
  }),
  downloadFFExceptionFile: (): MutationKeyConfig => ({
    mutationKey: [`DOWNLOAD_FF_EXCEPTION_FILE`],
    route: `/File/DownloadFFExceptionFile`,
    action: 'POST',
    disableSnackbar: true,
  }),
};
